import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  constructor() {}

  console_log(...args: any) {
    if(environment.console_logging) {
      console.log(...args);
    }
  }

  devLog(args: any) {
    if (!environment.production) console.log(args);
  }
}
